import { Action, ActionType, FilterType } from '../types'
import React, { FC, useEffect, useState } from 'react'
import { Box, Button, MenuItem, Select } from '@mui/material'
import { BodyUpdate } from './BodyUpdate'
import { Delete } from './Delete'
import { TypeChange } from './TypeChange'
import { ActionPreview } from './ActionPreview'

const actions: [
  string,
  ActionType,
  FC<{
    action?: Action
    onActionChange: (action: Action | undefined, done?: boolean) => void
    filterType: FilterType
  }>,
][] = [
  ['Delete', 'delete', Delete],
  ['Body Update', 'bodyUpdate', BodyUpdate],
  ['Type Change', 'typeChange', TypeChange],
]

export function Actions({
  action,
  onActionChange,
  filterType,
}: {
  action?: Action
  onActionChange: (action?: Action) => void
  filterType: FilterType
}) {
  const [adding, setAdding] = useState(false)
  return (
    <Box padding="20px" borderRadius="5px" border="solid 1px">
      <Box>
        Item Action
        <ActionToggle action={action} adding={adding} onToggle={setAdding} />
      </Box>
      {adding && (
        <AddingAction
          onActionChange={onActionChange}
          action={action}
          onAddingDone={() => setAdding(false)}
          filterType={filterType}
        />
      )}
      <ActionPreview action={action} clearAction={() => onActionChange()} />
    </Box>
  )
}

function ActionToggle({
  action,
  adding,
  onToggle,
}: {
  action?: Action
  adding: boolean
  onToggle(adding: boolean): void
}) {
  if (adding) {
    return <Button onClick={() => onToggle(false)}>Done</Button>
  }
  if (action?.actionType) {
    return <Button onClick={() => onToggle(true)}>Edit Action</Button>
  }
  return <Button onClick={() => onToggle(true)}>Add Action</Button>
}

function AddingAction({
  action,
  onActionChange,
  onAddingDone,
  filterType,
}: {
  action?: Action
  onActionChange: (action?: Action) => void
  onAddingDone: () => void
  filterType: FilterType
}) {
  const [selectedAction, setSelectedAction] = useState('')

  useEffect(() => {
    setSelectedAction(action?.actionType ?? '')
  }, [action])

  const [, , ActionComponent] =
    actions.find(([, value]) => value === selectedAction) ?? []

  const doOnActionChange = (action: Action | undefined, done?: boolean) => {
    onActionChange(action)
    if (done) {
      onAddingDone()
    }
  }

  return (
    <Box>
      <Select
        displayEmpty={true}
        value={selectedAction}
        onChange={({ target: { value } }) => setSelectedAction(value)}
        renderValue={(v) => (v ? String(v) : 'Select Action')}
      >
        {actions.map(([name, value]) => (
          <MenuItem value={value} key={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
      <Box padding="10px">
        {ActionComponent && (
          <ActionComponent
            onActionChange={doOnActionChange}
            action={action}
            filterType={filterType}
          />
        )}
      </Box>
    </Box>
  )
}
